/* istanbul ignore file */
import { useState } from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import LinkIcon from '@mui/icons-material/LinkOutlined';
import { Box } from '@mui/material';
import { copyToClipboard, copyByNavigator } from './clipboard';
import { useUiTheme } from 'framework/uiTheme';

interface Props {
  id: string;
  value: string;
  children: any;
  className?: string;
  isIcon?: boolean;
  sx?: {};
  boxSx?: {};
  isContentCopyIcon?: boolean;
  isCopyingFromModal?: boolean;
}

const STYLE = {
  outline: 'none',
  boxShadow: 'none',
  padding: 0,
};

const CopyToClipboardButton = ({
  id,
  value,
  children,
  className,
  isIcon = true,
  sx = {},
  boxSx = {},
  isContentCopyIcon = false,
  isCopyingFromModal = false,
}: Props) => {
  const [isCopied, setIsCopied] = useState(false);
  const { Button, Tooltip } = useUiTheme();

  const onClick = () => {
    if (isCopyingFromModal) {
      copyByNavigator(value);
    } else {
      copyToClipboard(value);
    }

    if (!isIcon) {
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 3000);
    }
  };

  const buttonText = isCopied ? <>Copied!</> : children;

  return (
    <Box className={className} sx={{ display: 'inline-block', ...boxSx }}>
      <Button
        type="button"
        onClick={onClick}
        style={isIcon ? STYLE : {}}
        link={!!isIcon}
        variant="outlined"
        color="neutral"
        sx={{ ...sx, minWidth: '1px' }}
      >
        {isIcon ? (
          <Tooltip title={children} placement="right" id={id}>
            {isContentCopyIcon ? (
              <ContentCopyIcon id={id} aria-label="Copy to clipboard" sx={{ fontSize: '21px' }} />
            ) : (
              <LinkIcon id={id} aria-label="Copy to clipboard" sx={{ fontSize: '21px' }} />
            )}
          </Tooltip>
        ) : (
          buttonText
        )}
      </Button>
    </Box>
  );
};

export default CopyToClipboardButton;
